import React from 'react'
import { Button, Form, Modal } from 'react-bootstrap'

const SubscrptionDetailsModal = (props) => {
  console.log("subscription:::::propsname::", props);
  return (
    <Modal show={true} size="md" centered onHide={props.handleClose}>
        <Modal.Header closeButton className="CNSHeader">
          <h5 className="uppercase m-0">{props?.subscription?.name}</h5>
        </Modal.Header>
        <Form noValidate>
          <Modal.Body>
          <div>
                    <p><strong>Product ID:</strong> {props.subscription?.productId}</p>
                    <p><strong>Purchase Date:</strong> {props.subscription?.purchaseDate}</p>
                    <p><strong>Expiry Date:</strong> {props.subscription?.expiryDate}</p>
                    <p><strong>Subscribed Platform:</strong> {props.subscription?.platform === "ios" ? "iOS" : props.subscription?.platform === "android" ? "Android" : ""}</p>
                    <p><strong>Trail Period:</strong> {props.subscription?.isTrialPeriod ? "Yes" : "No"}</p>
                    <p className='m-0'>
                        <strong>Status: </strong>
                        <span
                            className={`badge ${props.subscription?.status === "expired" ? "bg-danger" : "bg-success"}`}
                        >
                            {props.subscription?.status}
                        </span>
                    </p>
                </div>
            
          </Modal.Body>
          <Modal.Footer className="CNSFooter">
            <Button variant="secondary" onClick={props.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
  )
}

export default SubscrptionDetailsModal
